import script from "./RoadmapLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./RoadmapLoader.vue?vue&type=script&setup=true&lang=js"

import "./RoadmapLoader.vue?vue&type=style&index=0&id=600d902f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600d902f"]])

export default __exports__